import React, { useCallback, useEffect, useState } from 'react';
import API from '../../services/api';
import PaginationControls from '../../components/ui/PaginationControls';
import './Analytics.css';

const STATUS = [['', 'All'], ['new', 'New'], ['contacted', 'Contacted'], ['closed', 'Closed']];
const PAGE_SIZE = 25;
const fmt = (d) => new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

// Super admin only. Leads are prospects from the public site — separate from users, never shown to colleges.
export default function Leads() {
  const [status, setStatus] = useState('');
  const [items, setItems] = useState(null);
  const [err, setErr] = useState('');
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({ total: 0, total_pages: 1 });

  const load = useCallback(() => {
    setErr(''); setItems(null);
    const params = { page, limit: PAGE_SIZE };
    if (status) params.status = status;
    API.get('/leads', { params })
      .then(r => { setItems(r.data.data || []); setMeta(r.data.metadata || { total: 0, total_pages: 1 }); })
      .catch(e => setErr(e.response?.data?.message || 'We could not load leads.'));
  }, [status, page]);
  useEffect(() => { setPage(1); }, [status]);
  useEffect(load, [load]);

  const setLeadStatus = async (id, next) => {
    try { await API.patch(`/leads/${id}`, { status: next }); load(); }
    catch (e) { setErr(e.response?.data?.message || 'Could not update that lead.'); }
  };

  return (
    <div className="axh-page">
      <div className="axh-topbar"><div><h1>Leads</h1><p>Enquiries from the public website. These are not Zaptude users.</p></div></div>
      <div role="tablist" aria-label="Lead status" style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {STATUS.map(([k, l]) => <button key={k || 'all'} type="button" role="tab" aria-selected={status === k} className={`axh-btn${status === k ? ' primary' : ''}`} onClick={() => setStatus(k)}>{l}</button>)}
      </div>
      {err && <div className="axh-error" role="alert">{err} <button type="button" className="axh-btn" onClick={load}>Retry</button></div>}
      {!err && !items && <div className="axh-loading"><div className="axh-spinner" />Loading…</div>}
      {items && items.length === 0 && <div className="axh-card"><div className="axh-empty">No leads here yet.</div></div>}
      {items && items.map(l => (
        <div className="axh-card" key={l.id} style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
            <div><strong>{l.name}</strong>{l.organization ? ` · ${l.organization}` : ''}</div>
            <span style={{ fontSize: 12, color: 'var(--z-muted)' }}>{fmt(l.created_at)}</span>
          </div>
          <div style={{ margin: '4px 0' }}><a href={`mailto:${l.email}`}>{l.email}</a></div>
          {l.message && <p style={{ fontSize: 14, whiteSpace: 'pre-wrap' }}>{l.message}</p>}
          <label style={{ fontSize: 13 }}>Status{' '}
            <select value={l.status} onChange={e => setLeadStatus(l.id, e.target.value)}>
              <option value="new">New</option><option value="contacted">Contacted</option><option value="closed">Closed</option>
            </select>
          </label>
        </div>
      ))}
      {items && items.length > 0 && <PaginationControls page={page} totalPages={meta.total_pages} total={meta.total} onChange={setPage} />}
    </div>
  );
}
